module.exports = __webpack_public_path__ + "static/img/female-2.a612c66c.png";